import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Account/RegisterForm/registerForm.container"
    ).then((module) => ({
        default: module.RegisterFormContainer
    }))
);
